<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="title">npm 安装</div>
        <img src="https://img.shields.io/github/stars/yurencloud/yu.mobile.svg" alt="">
        <img src="https://img.shields.io/github/issues/yurencloud/yu.mobile.svg" alt="">
        <img src="https://img.shields.io/github/forks/yurencloud/yu.mobile.svg" alt="">
        <img src="https://img.shields.io/github/license/yurencloud/yu.mobile.svg" alt="">
        <pre v-highlightjs="code1"><code class="javascript"></code></pre>

        <div class="title">复制文件 安装</div>
        <div>复制scss文件 <a href="https://github.com/yurencloud/yu.mobile/tree/master/src/assets/css" style="color:#409EFF"
                         target="_blank">下载地址</a></div>
        <div>复制组件文件 <a href="https://github.com/yurencloud/yu.mobile/tree/master/src/components" style="color:#409EFF"
                       target="_blank">下载地址</a></div>
        <div>配置vue scss loader</div>
        <pre v-highlightjs="code5"><code class="javascript"></code></pre>
        <pre v-highlightjs="code6"><code class="javascript"></code></pre>

        <div>举例：如果你只想引入button组件，那么你只要复制button.vue文件和_varible.scss文件，并修改button.vue中的@import
          "../assets/css/varible";即可使用
        </div>

        <div class="title">配置字体图标</div>
        <div>在根目录下的index.html文件中引入外部字体图标css文件(注：如果你使用的组件中未使用到任何图标，可不引入)</div>
        <pre v-highlightjs="code2"><code class="html"></code></pre>

        <div class="title">快速上手：Hello World</div>
        <pre v-highlightjs="code3"><code class="javascript"></code></pre>
        <pre v-highlightjs="code4"><code class="html"></code></pre>
        <div style="margin-bottom: 20px;">最终结果</div>
        <div class="mobile-box">
          <yu-text><yu-button>Hello World</yu-button></yu-text>
        </div>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Button',
  data() {
    return {
      code1: `
  npm i -S yu.mobile
      `,
      code2: `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
      <title>yu-vue</title>
      <!--字体图标css-->
      <link rel="stylesheet" href="https://at.alicdn.com/t/font_657803_31srcimeac680k9.css">
      <!--字体图标css-->
    </head>
    <body>
      <div id="app"></div>
      <!-- built files will be auto injected -->
    </body>
  </html>
      `,
      code3: `
  // 引入yu-button组件
  import { YuButton } from 'yu.mobile';
  export default {
    name: 'Example',
    components: { YuButton },
  }
      `,
      code4: `
  <!--使用yu-button组件-->
  <yu-button>Hello world</yu-button>
      `,
      code5: `
  npm install --save-dev sass-loader
  npm install --save-dev node-sass
      `,
      code6: `
  // 修改build/webpack.base.conf.js文件
  module: {
    rules: [
      // ... 省略前面的配置
      // 添加scss 配置
      {
        test: /\\.scss$/,
        loaders: ["style", "css", "sass"]
      },
      ]
    }
      `,
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuButton,
    YuText,
  }
  ,
}
;
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  html {
    font-size: 50px;
  }

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }
    .mobile-box {
      height: 667px;
      width: 375px;
      border: 1px solid $border;
      border-radius: 10px;
      background: $background;
      overflow-y: scroll;
      font-size: 0;
      padding: 0;
      &::-webkit-scrollbar {
        width: 0;
      }
      &:hover {
        &::-webkit-scrollbar {
          width: 0;
        }
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: $border;
      }
      .addPadding {
        padding: 0 px2rem(14px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/install.vue